<template>
  <section
    ref="appLayoutContainer"
    class="sms-app-layout"
    :mobile="isMobileView"
    :style="layoutSetup"
    v-touch="{ left: close, right: open }"
  >
    <div class="overlay" :class="{ visible: isSidebarOpen }" @click="close" />
    <nav :class="{ open: isSidebarOpen }">
      <slot name="nav" :mobile="isMobileView"></slot>
    </nav>
    <main>
      <slot name="main" :mobile="isMobileView"></slot>
    </main>
  </section>
</template>

<script>
export default {
  name: 'SmsAppLayout',

  props: {
    fullWidthSidebarOnMobile: {
      type: Boolean,
      default: false
    },
    sidebarWidth: {
      type: Number,
      default: 360
    },
    mobileBreakpoint: {
      type: Number,
      default: 768
    }
  },

  data() {
    return {
      navWidth: 0,
      mainWidth: 0,
      isMobileView: false,
      isSidebarOpen: false,
      resizeObserver: null
    };
  },

  computed: {
    layoutSetup() {
      return {
        '--max-height': document.body.clientHeight,
        '--nav-width': this.navWidth,
        '--main-width': this.mainWidth
      };
    }
  },

  mounted() {
    this.$root.$on('open-sidebar', this.open);
    this.$root.$on('close-sidebar', this.close);
    this.$root.$on('toggle-sidebar', this.toggle);
    this.resizeObserver = new ResizeObserver(this.onResize).observe(this.$refs.appLayoutContainer);
  },

  beforeDestroy() {
    this.$root.$off('open-sidebar');
    this.$root.$off('close-sidebar');
    this.$root.$off('toggle-sidebar');
    delete this.resizeObserver;
  },

  methods: {
    open() {
      this.isSidebarOpen = true;
    },

    close() {
      this.isSidebarOpen = false;
    },

    toggle() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    onResize() {
      const availableWidth = document.body.clientWidth;

      if (availableWidth <= this.mobileBreakpoint) {
        if (this.fullWidthSidebarOnMobile) {
          this.navWidth = `100%`;
        } else {
          this.navWidth = this.sidebarWidth < availableWidth ? `${this.sidebarWidth}px` : `100%`;
        }
        this.mainWidth = `100%`;
        this.isMobileView = true;
      } else {
        this.navWidth = `${this.sidebarWidth}px`;
        this.mainWidth = `${availableWidth - this.sidebarWidth}px`;
        this.isMobileView = false;
      }

      this.isSidebarOpen = false;
    }
  }
};
</script>

<style src="./scoped.scss" lang="scss" scoped />
